// "Can You Trust an AI-Generated Diagram?" — source-diagram passthrough short.
// Cold Compute / Neon kit. ~130s @ 30fps.
//
// GROUNDED in EAKC-MVP (source-diagram passthrough shipped 2026-07-12, commit 2a8c15ea):
//   THE FIND — "give me the architecture diagram of the Action-Oriented Dynamic UI" produced a
//     confident mermaid diagram that PASSED the coverage grader but was the WRONG one (a mashup
//     of mission-step dispatch + the draft-approval widget). The real architecture — one
//     descriptor contract → three surfaces → one action spine — was hand-drawn in the source
//     doc and never made it in.
//   THE MECHANISM — RAG turns docs into text chunks; a diagram becomes TEXT. The model draws a
//     NEW diagram from prose instead of copying the real one; and if the diagram-bearing doc
//     embeds poorly it isn't even retrieved, so the model has nothing to copy from.
//   THE FIX — source-diagram passthrough: detect a diagram request, extract mermaid from a source
//     (fenced ```mermaid AND the <div class="mermaid"> HTML form), score by query-term overlap,
//     DB-rescue it if the doc ranked poorly, inject VERBATIM with a reproduce-exactly directive.
//     Synthesis becomes the labeled fallback. Honest label on screen: fully-deterministic render
//     is the named next slice. No fabricated numbers.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 420 }, //          0:00–0:14   asked for the diagram · got a confident, wrong one · grader passed it
  redraw: { start: 420, duration: 540 }, //      0:14–0:32   RAG redraws from prose · never copies the real diagram
  evidence: { start: 960, duration: 540 }, //    0:32–0:50   merged two subsystems · dropped the core · grader can't see faithfulness
  worse: { start: 1500, duration: 480 }, //      0:50–1:06   the diagram-bearing doc embedded poorly · wasn't even retrieved
  fix: { start: 1980, duration: 600 }, //        1:06–1:26   source-diagram passthrough · surface the real one verbatim
  how: { start: 2580, duration: 540 }, //        1:26–1:44   detect · extract (fenced + div) · match · rescue · inject verbatim
  lesson: { start: 3120, duration: 480 }, //     1:44–2:00   reproduce ground truth · synthesis is the fallback
  outro: { start: 3600, duration: 300 }, //      2:00–2:10
} as const;

export const TOTAL_DURATION = 3900; // 130s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
